import React from 'react'
import styles from "./clock.module.scss"
import { ReactComponent as Icon } from '../images/icons/ico-clock.svg';

export default class Clock extends React.Component {
  constructor(props) {
    super(props)

    this._mounted = false

    this.state = {
      timeLeft: null,
      tick: 0,
    }
  }

  _fromMillisToTime() {
    const leftSeconds = Math.round(
      ((this.state.timeLeft === null
        ? this.props.leftMilliseconds
        : this.state.timeLeft) || 0) / 1000
    )

    let minutes = Math.floor(leftSeconds / 60)
    let seconds = leftSeconds - 60 * minutes

    if (minutes < 10) {
      minutes = '0' + minutes
    }

    if (seconds < 10) {
      seconds = '0' + seconds
    }

    return minutes + ':' + seconds
  }

  componentDidMount() {
    this._mounted = true
  }

  componentWillUnmount() {
    this._mounted = false

    if (this._clockTimeout) {
      clearTimeout(this._clockTimeout)
    }
  }

  componentDidUpdate() {
    if (this._clockTimeout) {
      clearTimeout(this._clockTimeout)
    }

    if (!this.props.freeze) {
      this._clockTimeout = setTimeout(() => {
        if (this._mounted) {
          const delta = Date.now() - this.props.receivedAt

          this.setState({
            timeLeft: Math.max(
              0,
              this.props.leftMilliseconds - Math.max(0, delta)
            ),
            tick: this.state.tick + 1,
            counting: true,
          })
        }
      }, 100)
    } else if (this.state.counting) {
      const delta = Date.now() - this.props.receivedAt
      this.setState({
        timeLeft: Math.max(0, this.props.leftMilliseconds - Math.max(0, delta)),
        tick: this.state.tick,
        counting: false,
      })
    }
  }

  render() {
    if (this.props.onTick && !this.props.freeze && this.props.visible) {
      const leftSeconds = Math.round(
        ((this.state.timeLeft === null
          ? this.props.leftMilliseconds
          : this.state.timeLeft) || 0) / 1000
      )
      this.props.onTick(leftSeconds)
    }

    return (
      <div
        className={`${styles.clock}
          ${!this.props.visible ? styles.hidden : ""}
          ${!this.props.freeze ? styles.active : ""}
        `}
      >
        <Icon />
        {this._fromMillisToTime()}
      </div>
    )
  }
}
